import { IConfiguration } from 'store/configuration/types';

export const CONTACT_PICKER_SUFFIX = 'contact';

export const TICKET_PICKER_SUFFIX = 'ticket contact';

export const CONTACT_NO_PHONE =
  'This contact has no phone number on file. Enter a number to call.';

export const RECENTS_EMPTY_CONTACT = 'No calls with this contact yet';

export const RECENTS_EMPTY_TICKET = 'No calls on this ticket yet';

export const RECENTS_EMPTY_OWN_CONTACT = 'None of your calls are with this contact yet';

export const RECENTS_EMPTY_OWN_TICKET = 'None of your calls are on this ticket';

export const RECENTS_OWN_HINT_CONTACT =
  'You see the calls you placed. Others may have called this contact.';

export const RECENTS_OWN_HINT_TICKET =
  'You see the calls you placed. Others may have called on this ticket.';

export const RECENTS_OWN_NOTE_CONTACT =
  'Showing the calls you placed. This contact may have others.';

export const RECENTS_OWN_NOTE_TICKET =
  'Showing the calls you placed. This ticket may have others.';

export const TICKETLESS_REVIEW_NOTE =
  'This call was placed from a contact record, so there is no ticket to post it to.';

export const isContactScreen = (
  config: Partial<IConfiguration> | null | undefined,
): boolean => config?.screen === 'contact';
